import {MAX_ENTITIES_MULTI_SELECT, SELECT_ALL_OBJECT, VARIANT_SITES} from "../../../Constants/constants";
import {Multiselect} from "multiselect-react-dropdown";
import React, {useEffect, useState} from "react";

export default function DataMultiSelector(props) {
    let copyEntities = props?.entities ? [...props?.entities] : [];
    if (!props.selectionLimit) {
        copyEntities.unshift(SELECT_ALL_OBJECT);
    }

    const placeholderLabel = `Select ${props?.variant === VARIANT_SITES ? 'Sites' : 'Systems'} (${props?.selectedValues?.length}/${props?.entities?.length})`;
    const [options, setOptions] = useState(copyEntities?.size <= MAX_ENTITIES_MULTI_SELECT ? copyEntities : copyEntities?.slice(0, MAX_ENTITIES_MULTI_SELECT));
    const [loading, setLoading] = useState(false);
    const [selectAll, setSelectAll] = useState(false);
    const [placeHolder, setPlaceHolder] = useState(props?.entities?.length > 0 ? `${props?.entities?.length} Total` : placeholderLabel);
    const [lastSearchTerm, setLastSearchTerm] = useState('');

    const searchHandle = (value) => {
        if (value?.length === 0) {
            setLastSearchTerm('');
            return;
        }
        setLoading(true);
        let elementsToAdd = findElement(value);
        if (!elementsToAdd) return;
        setOptions(elementsToAdd);
        setLastSearchTerm(value);
    }

    const findElement = (value) => {
        let found = props?.entities?.filter(obj => obj?.label?.toLowerCase().includes(value?.toLowerCase()));
        setLoading(false);
        return found
    }

    const isSelectAll = (selectedList) => {
        if (selectedList.find((a) => a.value === SELECT_ALL_OBJECT.value) && !selectAll) {
            setSelectAll(true);
        }
        if (!selectedList.find((a) => a.value === SELECT_ALL_OBJECT.value) && selectAll) {
            setSelectAll(false);
        }
    }
    const onSelectHandle = (selectedList) => {
        isSelectAll(selectedList);
        if (selectedList.find((a) => a.value === SELECT_ALL_OBJECT.value) && !selectAll) {
            let copyArray = [...copyEntities];
            copyArray.shift();
            props.setSelectedValues(copyArray.sort(function (a, b) {
                return a.value - b.value;
            }))
            copyEntities.unshift(SELECT_ALL_OBJECT);

        } else if (!selectAll) {
            props.setSelectedValues(selectedList.sort(function (a, b) {
                return a.value - b.value;
            }))
        }
    }

    const onRemoveHandle = (selectedList) => {
        isSelectAll(selectedList);
        if (!selectedList.find((a) => a.value === SELECT_ALL_OBJECT.value) && selectAll) {
            props.setSelectedValues([]);
        } else if (!selectAll) {
            props.setSelectedValues(selectedList.sort(function (a, b) {
                return a.value - b.value;
            }))
        }

    }

    useEffect(() => {
        setPlaceHolder(`${props?.entities?.length} Total`);
        if (!options.find((a) => a.value === SELECT_ALL_OBJECT.value) && !props.selectionLimit) {
            options.unshift(SELECT_ALL_OBJECT);
        }
    }, [options]);


    useEffect(() => {
        if (props?.entities?.length > 0) {
            let finalOptions = [...props.selectedValues];
            let ids = finalOptions?.map((a) => a.value);
            let leftOversEntities = [...props.entities]?.map((a) => {
                if (!ids.includes(a.value)) return a
            }).filter((x) => x !== undefined)
            if (leftOversEntities?.length > 0) {
                let index = 0;
                let min = Math.min(10, finalOptions.length + leftOversEntities.length);
                while (finalOptions.length < min) {
                    if (leftOversEntities[index]) {
                        finalOptions.push(leftOversEntities[index]);
                    }
                    index++;
                }
                if (lastSearchTerm !== '') {
                    finalOptions = options.filter(a => a.label.includes(lastSearchTerm));
                }
                setOptions(finalOptions);
                setPlaceHolder(`${props?.entities?.length} Total`);
            }
        }
    }, [props.selectedValues, lastSearchTerm]);


    return (<Multiselect
        options={options}
        selectedValues={selectAll ? copyEntities : props.selectedValues}
        style={{chips: {visibility: 'hidden', position: 'absolute', zIndex: -1000, fontSize: 'revert'}}}
        showCheckbox
        placeholder={placeholderLabel}
        closeOnSelect={false}
        hidePlaceholder={false}
        keepSearchTerm={true}
        loading={loading}
        avoidHighlightFirstOption
        onSelect={(selectedList) => onSelectHandle(selectedList)}
        onRemove={(selectedList) => onRemoveHandle(selectedList)}
        onSearch={(value) => searchHandle(value)}
        selectionLimit={props.selectionLimit || -1}
        disablePreSelectedValues={props.selectedValues?.length <= 1}
        displayValue="label"
        showArrow/>)
}
